import React, { useEffect, useState } from "react";
import { Box, CssBaseline } from "@mui/material";
import DataGridComponent from "./DataGridComponent";
import { useDispatch, useSelector } from "react-redux";
import { getTenantDetail } from "../../features/tenantDetail/tenantDetailAction";
import moment from "moment";
const Dashboard = () => {
  const dispatch = useDispatch();
  const [tenants, setTenants] = useState([]);
  const tenantList = useSelector((state) => state.tenantDetail);

  useEffect(()=> {
    if (tenantList?.data?.length) {
      const filteredData = tenantList.data.map((row) => {
        return {
        id: row?.tenantId,
        tenant: row?.tenant,
        status: row?.status,
        primary: row?.isPrimary ? "Active" : "Inactive",
        expiration: row?.expirationDate ? moment(row.expirationDate).format("DD-MM-YYYY") : "",
        createdOn: row?.lastModified ? moment(row.lastModified).format("DD-MM-YYYY") : "",
      }
    });
      setTenants(filteredData)
    }
  }, [tenantList])

  useEffect(()=> {
    getTenantDetailsData();
  },[])

  const getTenantDetailsData = () => {
    dispatch(getTenantDetail());
  };

  return (

    <Box sx={{ display: "flex" }}>
      <CssBaseline/>
        <DataGridComponent rows={tenants} setRows={setTenants}/>
    </Box>
  );
};

export default Dashboard;
